import React from "react";
import DeviceContext from "../../../../utils/indentifyDevice";
import "../../../../stylesheets/components/Reports/HoldingReports/QtyDrop.scss";
import { GTMService } from "@di";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
const QtyDrop = ({ qts, changeTableData, setshowQtyDropdown, }) => {
    const HandleOnClick = (el) => {
        setshowQtyDropdown(false);
        if (el.title == "All Quantity") {
            changeTableData("AllQty");
            GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.Allqty, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, ReportsGTMConstants.Allqty));
        }
        else {
            changeTableData("tradableQty");
            GTMService.gtmService(new ReportGAEvents(ReportsGTMConstants.Allqty, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Holding}`, ReportsGTMConstants.TrdQty));
        }
    };
    return (React.createElement("div", { className: DeviceContext().isMobile ? "qty-drop-mob" : "qty-drop" },
        React.createElement("div", { className: DeviceContext().isMobile ? "qty-drop-body-mob" : "qty-drop-body" },
            React.createElement("ul", { className: "qty-drop-bodylist" }, qts.map((val, idx) => {
                return (React.createElement("li", { key: idx },
                    React.createElement("label", { onClick: () => {
                            HandleOnClick(val);
                        } }, val.title)));
            })))));
};
export default QtyDrop;
